import styled from "styled-components";
import { Alert } from "@material-ui/lab";

export const StyledAlert = styled(Alert)`
    z-index: ${({ theme }) => theme.zIndex.modal + 2};
    position: fixed;
    top: 10px;
    left: 50%;
    transform: translateX(-50%);

    .MuiAlert-message {
        margin: auto;
    }
`;
